import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import cn from 'classnames'
import { MoreVertical } from 'lucide-react'
import styles from './stream-header-menu.module.scss'

// Overflow "⋯" menu for the stream header controls. Children is a render-prop
// that receives a `close` callback so plain action rows can dismiss the menu;
// self-contained popover rows (e.g. stream filters) simply don't call it.
export default function StreamHeaderMenu({ triggerClassName, children }) {
    const [open, setOpen] = useState(false)
    const btnRef = useRef(null)
    const menuRef = useRef(null)

    useEffect(() => {
        if (!open) return
        const handleClickOutside = event => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                btnRef.current &&
                !btnRef.current.contains(event.target) &&
                // keep open while a nested popover (stream filters) is in use
                !event.target.closest('[class*="mutedStreamsPopover"]')
            ) {
                setOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [open])

    const rect = btnRef.current?.getBoundingClientRect()
    /** @type {React.CSSProperties} */
    const menuStyle = rect
        ? {
              position: 'absolute',
              top: rect.bottom + 6,
              right: window.innerWidth - rect.right,
              zIndex: 1000,
          }
        : {}

    return (
        <>
            <div
                ref={btnRef}
                className={cn(styles.trigger, triggerClassName)}
                onClick={ev => {
                    ev.stopPropagation()
                    setOpen(current => !current)
                }}
                role="button"
                aria-label="More options"
                aria-expanded={open}
            >
                <MoreVertical size={18} />
            </div>
            {open &&
                ReactDOM.createPortal(
                    <div ref={menuRef} className={styles.menu} style={menuStyle}>
                        {children(() => setOpen(false))}
                    </div>,
                    document.body,
                )}
        </>
    )
}
